import { render } from "./overview.vue?vue&type=template&id=e3ae4d64"
import script from "./overview.vue?vue&type=script&lang=ts"
export * from "./overview.vue?vue&type=script&lang=ts"
script.render = render

export default script